<div class="wrapper">

  <section id="banner-hoteis" class="banner-container hero is-medium banner-header-hoteis">
    <div class="hero-body bg-hoteis-destinos">
      <div class="container">
        <div class="area-breadcrumb">
          <nav class="breadcrumb">
            <ul>
              <li><a href="/"><strong>Home</strong></a></li>
              <span><i class="fas fa-chevron-right"></i></span>
              <li><a routerLink="/hoteis"><strong>Hotéis</strong></a></li>
              <span><i class="fas fa-chevron-right"></i></span>
              <li>Resultado</li>
            </ul>
          </nav>
        </div>
        <h1 class="title has-text-white">Os melhores hotéis, pousadas e resorts <br>estão na Montreal</h1>
        <app-busca-hoteis></app-busca-hoteis>
      </div>
    </div>
  </section>

<!--  <section id="filtro-rapido" *ngIf="!isMobile">-->
<!--    <div class="container is-fluid">-->
<!--      <div class="columns">-->
<!--        <div id="filteritem" class="column is-offset-3">-->
<!--          <div class="area-step-category">-->
<!--            <div class="step-one">-->
<!--              <h3 id='oquevocedeseja' class="subtitle">O que você deseja?</h3>-->
<!--              <div class="item-check icon-praia cursor-pointer"><a (click)="loadAtalhoHoteisPorTipoComodidade(23)"><i-->
<!--                    class="fas fa-sun"></i><span>Praia</span></a></div>-->
<!--              <div class="item-check icon-luxo cursor-pointer"><a (click)="loadHoteisLuxo()"><i-->
<!--                    class="fas fa-gem"></i><span>Luxo</span></a></div>-->
<!--              <div class="item-check icon-relaxar cursor-pointer"><a (click)="loadAtalhoHoteisPorTipoComodidade(24)"><i-->
<!--                    class="fas fa-spa"></i><span>Relaxar</span></a></div>-->
<!--              <div class="item-check icon-natureza cursor-pointer"><a (click)="loadAtalhoHoteisPorTipoComodidade(19)"><i-->
<!--                    class="fas fa-mountain"></i><span>Natureza</span></a></div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--  </section>-->

  <section id="lista-hoteis">
    <div class="container is-fluid">

      <div class="columns">
        <div *ngIf="isMobile" class="mobile-title-filter">
          <div>
            <a (click)="onShowFilter(true)"><i class="fas fa-filter"></i><span>Filtrar</span></a>
          </div>
        </div>
        <div id="montreal-hotel-busca" class="column is-3" *ngIf="onShowFilter()">
          <form class="sample-form" method="post" action-xhr="/documentation/examples/api/  submit-form-xhr" target="_top">
            <br/>

            <h4>Filtrar</h4>
            <a class="remover-filtros" style="cursor: pointer" href="/busca-hoteis">
              <i class="fas fa-trash"></i>Remover filtros aplicados
            </a>

            <div id="crianca-gratis" class=" div-filtro accordion" *ngIf="resultFiltros && resultFiltros?.criancaGratis">
              <input type="checkbox" id="btnControl-0" class="btn-control" />
              <label class="btn" for="btnControl-0">
                <div class="accordion-filtros">
                  <p *ngIf="resultFiltros?.criancaGratis?.itens.length">
                    <i class="fas fa-chevron-down"></i>
                    <strong>{{resultFiltros?.criancaGratis?.descricao ? resultFiltros?.criancaGratis?.descricao.toLocaleUpperCase() : "CRIANÇA GRÁTIS"}}</strong>                  </p>
                  <label class="area-check" [for]="item.id+item.descricao"
                         *ngFor="let item of resultFiltros?.criancaGratis.itens">
                    <input type="checkbox"
                           [(ngModel)]="item.checked"
                           (change)="loadHoteisAvancado()"
                           [value]="item.id"
                           [id]="item.id+item.descricao"
                           [name]="item.id+item.descricao">
                    <span class="check-item"></span>
                    <small>{{item.descricao}}</small>
                    <span class="checkmark"><i class="fas fa-check"></i></span>
                  </label>
                </div>
              </label>
            </div>

            <div id="hotel" class=" div-filtro accordion" *ngIf="resultFiltros">
              <input type="checkbox" id="btnControl-1" class="btn-control" />
              <label class="btn" for="btnControl-1">
                <div class="accordion-filtros">
                  <p *ngIf="resultFiltros?.hotel?.itens.length">
                    <i class="fas fa-chevron-down"></i>
                    <strong>{{resultFiltros?.hotel.descricao.toLocaleUpperCase()}}</strong>
                  </p>
                  <label class="area-check" [for]="item.id+item.descricao"
                         *ngFor="let item of resultFiltros?.hotel.itens">
                    <input type="checkbox"
                           [(ngModel)]="item.checked"
                           (change)="loadHoteisAvancado()"
                           [value]="item.id"
                           [id]="item.id+item.descricao"
                           [name]="item.id+item.descricao">
                    <span class="check-item"></span>
                    <small>{{item.descricao}}</small>
                    <span class="checkmark"><i class="fas fa-check"></i></span>
                  </label>
                </div>
              </label>
            </div>

            <div id="categoria-hotel" class=" div-filtro accordion" *ngIf="resultFiltros">
              <input type="checkbox" id="btnControl-2" class="btn-control" />
              <label class="btn" for="btnControl-2">
                <div class="accordion-filtros">
                  <p *ngIf="resultFiltros?.tipoPlano?.itens.length">
                    <i class="fas fa-chevron-down"></i>
                    <strong>{{resultFiltros?.tipoPlano.descricao.toLocaleUpperCase()}}</strong>
                  </p>
                  <label class="area-check" [for]="item?.id+item?.descricao"
                    *ngFor="let item of resultFiltros?.tipoPlano.itens">
                    <input type="checkbox" [(ngModel)]="item.checked" (change)="loadHoteisAvancado()" [value]="item.id"
                      [id]="item.id+item.descricao" [name]="item.id+item.descricao">
                    <span class="check-item"></span>
                    <small>{{item.descricao}}</small>
                    <span class="checkmark"><i class="fas fa-check"></i></span>
                  </label>
                </div>
              </label>
            </div>

            <div id="tipo-hotel" class=" div-filtro accordion" *ngIf="resultFiltros">
              <input type="checkbox" id="btnControl-3" class="btn-control" />
              <label class="btn" for="btnControl-3">
                <div class="accordion-filtros">
                  <p *ngIf="resultFiltros?.tipoHotel?.itens.length">
                    <i class="fas fa-chevron-down"></i>
                    <strong>{{resultFiltros?.tipoHotel.descricao.toLocaleUpperCase()}}</strong>
                  </p>
                  <label class="area-check" [for]="item.id+item.descricao"
                    *ngFor="let item of resultFiltros?.tipoHotel.itens">
                    <input type="checkbox" [(ngModel)]="item.checked" (change)="loadHoteisAvancado()" [value]="item.id"
                      [id]="item.id+item.descricao" [name]="item.id+item.descricao">
                    <span class="check-item"></span>
                    <small>{{item.descricao}}</small>
                    <span class="checkmark"><i class="fas fa-check"></i></span>
                  </label>
                </div>
              </label>
            </div>

            <div id="tipo-apartamento" class=" div-filtro accordion" *ngIf="resultFiltros">
              <input type="checkbox" id="btnControl-4" class="btn-control" />
              <label class="btn" for="btnControl-4">
                <div class="accordion-filtros">
                  <p *ngIf="resultFiltros?.tipoApartamento?.itens.length">
                    <i class="fas fa-chevron-down"></i>
                    <strong>{{resultFiltros?.tipoApartamento.descricao.toLocaleUpperCase()}}</strong>
                  </p>
                  <label class="area-check" [for]="item.id+item.descricao"
                    *ngFor="let item of resultFiltros?.tipoApartamento.itens">
                    <input type="checkbox" [(ngModel)]="item.checked" (change)="loadHoteisAvancado()" [value]="item.id"
                      [id]="item.id+item.descricao" [name]="item.id+item.descricao">
                    <span class="check-item"></span>
                    <small>{{item.descricao}}</small>
                    <span class="checkmark"><i class="fas fa-check"></i></span>
                  </label>
                </div>
              </label>
            </div>

            <div id="tipo-quarto" class=" div-filtro accordion" *ngIf="resultFiltros">
              <input type="checkbox" id="btnControl-5" class="btn-control" />
              <label class="btn" for="btnControl-5">
                <div class="accordion-filtros">
                  <p *ngIf="resultFiltros?.tipoQuarto?.itens.length">
                    <i class="fas fa-chevron-down"></i>
                    <strong>{{resultFiltros?.tipoQuarto.descricao.toLocaleUpperCase()}}</strong>
                  </p>
                  <label class="area-check" [for]="item.id+item.descricao"
                    *ngFor="let item of resultFiltros?.tipoQuarto.itens">
                    <input type="checkbox" [(ngModel)]="item.checked" (change)="loadHoteisAvancado()" [value]="item.id"
                      [id]="item.id+item.descricao" [name]="item.id+item.descricao">
                    <span class="check-item"></span>
                    <small>{{item.descricao}}</small>
                    <span class="checkmark"><i class="fas fa-check"></i></span>
                  </label>
                </div>
              </label>
            </div>

            <div id="regime-alimentacao" class=" div-filtro accordion" *ngIf="resultFiltros">
              <input type="checkbox" id="btnControl-6" class="btn-control" />
              <label class="btn" for="btnControl-6">
                <div class="accordion-filtros">
                  <p *ngIf="resultFiltros?.regimesAlimentacao?.itens.length">
                    <i class="fas fa-chevron-down"></i>
                    <strong>{{resultFiltros?.regimesAlimentacao?.descricao ? resultFiltros?.regimesAlimentacao?.descricao.toLocaleUpperCase() : "REGIME DE ALIMENTAÇÃO"}}</strong>
                  </p>
                  <label class="area-check" [for]="item.id+item.descricao"
                    *ngFor="let item of resultFiltros?.regimesAlimentacao?.itens">
                    <input type="checkbox" [(ngModel)]="item.checked" (change)="loadHoteisAvancado()" [value]="item.id"
                      [id]="item.id+item.descricao" [name]="item.id+item.descricao">
                    <span class="check-item"></span>
                    <small>{{item.descricao}}</small>
                    <span class="checkmark"><i class="fas fa-check"></i></span>
                  </label>
                </div>
              </label>
            </div>

            <div id="tipo-estado" class=" div-filtro accordion" *ngIf="resultFiltros">
              <input type="checkbox" id="btnControl-7" class="btn-control" />
              <label class="btn" for="btnControl-7">
                <div class="accordion-filtros">
                  <p *ngIf="resultFiltros?.estado.itens.length > 0">
                    <i class="fas fa-chevron-down"></i>
                    <strong>{{resultFiltros?.estado.descricao.toLocaleUpperCase()}}</strong>
                  </p>
                  <label class="area-check" [for]="item.id+item.descricao"
                    *ngFor="let item of resultFiltros.estado.itens">
                    <input type="checkbox" [(ngModel)]="item.checked" (change)="loadHoteisAvancado()" [value]="item.id"
                      [id]="item.id+item.descricao" [name]="item.id+item.descricao">
                    <span class="check-item"></span>
                    <small>{{item.descricao}}</small>
                    <span class="checkmark"><i class="fas fa-check"></i></span>
                  </label>
                </div>
              </label>
            </div>

            <div id="tipo-cidade" class=" div-filtro accordion" *ngIf="resultFiltros">
              <input type="checkbox" id="btnControl-8" class="btn-control" />
              <label class="btn" for="btnControl-8">
                <div class="accordion-filtros">
                  <p *ngIf="resultFiltros?.cidade.itens.length > 0">
                    <i class="fas fa-chevron-down"></i>
                    <strong>{{resultFiltros?.cidade.descricao.toLocaleUpperCase()}}</strong>
                  </p>
                  <label class="area-check" [for]="item.id+item.descricao"
                    *ngFor="let item of resultFiltros?.cidade.itens">
                    <input type="checkbox" [(ngModel)]="item.checked" (change)="loadHoteisAvancado()" [value]="item.id"
                      [id]="item.id+item.descricao" [name]="item.id+item.descricao">
                    <span class="check-item"></span>
                    <small>{{item.descricao}}</small>
                    <span class="checkmark"><i class="fas fa-check"></i></span>
                  </label>
                </div>
              </label>
            </div>

            <div id="tipo-bairro" class=" div-filtro accordion" *ngIf="resultFiltros">
              <input type="checkbox" id="btnControl-9" class="btn-control" />
              <label class="btn" for="btnControl-9">
                <div class="accordion-filtros">
                  <p *ngIf="resultFiltros?.bairro.itens.length > 0">
                    <i class="fas fa-chevron-down"></i>
                    <strong>{{resultFiltros?.bairro.descricao.toLocaleUpperCase()}}</strong>
                  </p>
                  <label class="area-check" [for]="item.id+item.descricao"
                    *ngFor="let item of resultFiltros?.bairro.itens">
                    <input type="checkbox" [(ngModel)]="item.checked" (change)="loadHoteisAvancado()" [value]="item.id"
                      [id]="item.id+item.descricao" [name]="item.id+item.descricao">
                    <span class="check-item"></span>
                    <small>{{item.descricao}}</small>
                    <span class="checkmark"><i class="fas fa-check"></i></span>
                  </label>
                </div>
              </label>
            </div>

            <div id="comodidade" *ngFor="let itemComodidade of resultFiltros?.comodidades">
              <div class=" div-filtro accordion" *ngIf="resultFiltros">
                <input type="checkbox" [id]="itemComodidade.idGrupo+itemComodidade.grupo" class="btn-control" />
                <label class="btn" [for]="itemComodidade.idGrupo+itemComodidade.grupo">
                  <div class="accordion-filtros">
                    <p>
                      <i class="fas fa-chevron-down"></i>
                      <strong>{{itemComodidade.grupo ? itemComodidade.grupo.toLocaleUpperCase() : ""}}</strong>
                    </p>
                    <label class="area-check" [for]="item.id+item.descricao"
                      *ngFor="let item of itemComodidade.comodidades">
                      <input type="checkbox" [(ngModel)]="item.checked" (change)="loadHoteisAvancado()"
                        [value]="item.id" [id]="item.id+item.descricao" [name]="item.id+item.descricao">
                      <span class="check-item"></span>
                      <small>{{item.descricao}}</small>
                      <span class="checkmark"><i class="fas fa-check"></i></span>
                    </label>
                  </div>
                </label>
              </div>
            </div>
          </form>
        </div>
        <div id="montreal-hotel" class="column is-9 resultado-hoteis">
          <div id="cabecalho-lista-hotel" class="columns">
            <div class="column is-7" *ngIf="!isMobile">
              <div class="result-message">
                Resultados para
                <strong class="local-pesquisado">{{resultHoteis && resultHoteis.data ? resultHoteis.data.nome : ''}}</strong>
              </div>
            </div>
          </div>
          <div id="corpo-lista-hotel" class="item-hotel-list" *ngIf="hoteisSite">

            <div class="item-hotel small-hotel" *ngFor="let item of hoteisSite">
              <a (click)="navegarParaDetalheHotel(item)">
                <figure>
                  <img class="bg-hotel" [src]="item.fotos[0]" />
                </figure>
                <div class="footer-hotel">
                  <div class="columns">
                    <div class="column is-7">
                      <h3>{{item.nome}}</h3>
                      <p *ngIf="!item.internacional">{{item.cidade}}, {{item.uf}}</p>
                      <p *ngIf="item.internacional">{{item.cidade}} - {{item.pais}}</p>
                      <small>{{item.descricao}}</small>
                      <a (click)="navegarParaDetalheHotel(item)" class="link-detalhes">Ver detalhes</a>
                    </div>
                    <br *ngIf="isMobile">
                    <div class="column is-5 has-text-right">
                      <div class="area-right">
                        <p class="tag">A partir do plano {{item.tipoPlano}}</p>
                        <a (click)="navegarParaDetalheHotel(item)" class="btn btn-primary"><i class="fa fa-user"></i>
                          Saiba Mais</a>
                      </div>
                    </div>
                  </div>
                </div>
              </a>
            </div>

            <ul class="pagination">
              <li class="prev"><a (click)="anteriorGrupoPaginacao()"><i class="fas fa-chevron-left"></i></a></li>

              <li [ngClass]="{'current': item.numeroPagina == paginaAtual }" *ngFor="let item of paginacao"><a
                  (click)="loadHoteisPorPaginacao(item.numeroPagina)">{{item.numeroPagina}}</a>
              </li>

              <li class="next"><a (click)="proximoGrupoPaginacao()"><i class="fas fa-chevron-right"></i></a></li>
            </ul>

          </div>
        </div>
      </div>
    </div>
  </section>
  <app-tabela-diarias-facilita></app-tabela-diarias-facilita>
  <app-footer></app-footer>
  <ng-template #filter>
    <form class="sample-form" method="post" target="_top">
      <br/>

      <h4>Filtrar</h4>
      <a class="remover-filtros" style="cursor: pointer" href="/busca-hoteis">
        <i class="fas fa-trash"></i>Remover filtros aplicados
      </a>

      <div *ngIf="resultFiltros">
        <div *ngFor="let item of convertArray(resultFiltros)" class=" div-filtro accordion">
          <input type="checkbox" [id]="item[0]" class="btn-control" *ngIf="isFilterValid(item)"/>
          <label class="btn" [for]="item[0]" *ngIf="isFilterValid(item)">
            <div class="accordion-filtros">
              <p *ngIf="item[1]?.itens && item[1]?.itens.length">
                <i class="fas fa-chevron-down"></i>
                <strong>{{item[1]?.descricao | uppercase}}</strong>
              </p>
              <label class="area-check" *ngFor="let i of item[1]?.itens" [for]="i.id+i.descricao">
                <input type="checkbox" [(ngModel)]="i.checked"/>
<!--                       [(ngModel)]="i.checked"-->
<!--                       (change)="loadHoteisAvancado()"-->
<!--                       [value]="i.id"-->
<!--                       [id]="i.id+i.descricao"-->
<!--                       [name]="i.id+i.descricao">-->
                <span class="check-item"></span>
                <small>{{i.descricao}}</small>
                <span class="checkmark"><i class="fas fa-check"></i></span>
              </label>
            </div>
          </label>
        </div>
      </div>
    </form>
  </ng-template>
</div>
